import styled from "@emotion/styled";
export const FooterRoot = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding: ${(props) => props.hasPadding ? "2rem" : "0"} 2rem 2rem;
`;
